export default "__VITE_ASSET__lMJ2rjxn__"